import { Badge, Box, Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FiAlertTriangle } from "react-icons/fi";
import { api } from "../../../services/api";

const DELIVERY_STATUS_LABEL = {
  pending:          "Aguardando",
  out_for_delivery: "Em entrega",
};

// Self-contained — fetches its own data so it can drop into both the
// Dashboard's default view and the Pedidos screen without either page having
// to thread period-independent data through its own (month-scoped) fetch.
// "Atrasado" is measured from days since payment (no expected-delivery-date
// field exists anywhere in the data model today), computed server-side —
// see BatchOrdersController#overdue.
export function OverdueOrdersAlert({ limit = 6 }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchOverdue() {
      try {
        const response = await api.get("/api/v1/batch_orders/overdue");
        setOrders(response.data || []);
      } catch (error) {
        console.error("Error fetching overdue orders:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchOverdue();
  }, []);

  if (loading || orders.length === 0) return null;

  return (
    <Box
      bg="white" borderRadius="16px" border="1px solid rgba(231,76,60,.3)"
      boxShadow="0 2px 12px rgba(0,74,51,.05)" p="16px 18px" mb="20px"
    >
      <Flex align="center" gap="8px" mb="10px">
        <FiAlertTriangle size={15} color="#e74c3c" />
        <Text fontSize="12px" fontWeight="800" color="#e74c3c">
          {orders.length} pedido{orders.length !== 1 ? "s" : ""} pago{orders.length !== 1 ? "s" : ""} com entrega atrasada
        </Text>
      </Flex>
      <Box display="flex" flexDirection="column" gap="2px">
        {orders.slice(0, limit).map(o => (
          <Flex key={o.id} justify="space-between" align="center" py="5px" borderBottom="1px solid rgba(0,74,51,.05)">
            <Box minW="0">
              <Text fontSize="12px" fontWeight="700" color="gray.700" noOfLines={1}>
                #{o.id} — {o.client_name || "Cliente"} · {o.product_name || "Produto"}
              </Text>
              <Text fontSize="10px" color="gray.400">
                {DELIVERY_STATUS_LABEL[o.delivery_status] || o.delivery_status} · {o.delivery_method === "collect" ? "Retirada" : "Entrega"}
              </Text>
            </Box>
            <Badge colorScheme="red" fontSize="9px" borderRadius="4px" flexShrink={0}>
              {o.days_overdue}d atrasado
            </Badge>
          </Flex>
        ))}
      </Box>
      {orders.length > limit && (
        <Text fontSize="11px" color="gray.400" mt="6px">+{orders.length - limit} outro{orders.length - limit !== 1 ? "s" : ""}</Text>
      )}
    </Box>
  );
}
